import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import ar from '../locales/ar';
import en from '../locales/en';

const translations = { ar, en };

const getNestedValue = (obj, key) => {
  return key.split('.').reduce((acc, part) => acc?.[part], obj);
};

const useLanguage = () => {
  const { user } = useContext(AuthContext);
  const language = user?.locale || 'ar';
  const locale = translations[language] || translations.ar;

  const t = (key) => {
    const value = getNestedValue(locale, key);

    if (value !== undefined) return value;

    // Missing key: warn in dev, fallback to Arabic
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[useLanguage] Missing translation key: "${key}" for locale "${language}"`);
    }

    return getNestedValue(translations.ar, key) || key;
  };

  return {
    language,
    t,
    isArabic: language === 'ar',
    isEnglish: language === 'en'
  };
};

export default useLanguage;
